var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"container"},[_c('h1',[_vm._v("Todo app")]),_c('addTodo'),_c('filterTodos'),_c('Todos')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }